var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignupDecorationRight = function SvgSignupDecorationRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 77,
    viewBox: "0 0 61 77"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 47 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 22,
    x: 20.731,
    y: -2.068,
    rx: 3,
    transform: "rotate(-55 23.731 8.932)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 22,
    x: 8.098,
    y: 18.547,
    rx: 3,
    transform: "rotate(-88 11.098 29.547)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 24,
    x: 20.766,
    y: 39.068,
    rx: 3,
    transform: "rotate(-122 23.766 51.068)"
  }))));
};
export default SvgSignupDecorationRight;